/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            ...theme.custom.appListingPage.styles
        },
        content: {
            marginTop: theme.spacing(13),
            overflow: 'auto',
        },
        cellContent: {
            paddingLeft: theme.spacing(1)
        },
        pageTitle: {
            ...theme.custom.appListingPage.title
        },
        subtitle: {
            marginTop: theme.spacing(1),
            ...theme.custom.appListingPage.subTitle
        },
        moreButtons: {
            display: 'flex',
            alignItems: "center",
            justifyContent: "flex-end"
        },
        deleteBtn: {
            height: theme.spacing(4),
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(2),
            borderRadius: theme.spacing(2),
            marginLeft: theme.spacing(0.5),
            backgroundSize: theme.spacing(2.5),
            ...theme.custom.appListingPage.appDeleteButtonStyle
        },
        btnText: {
            marginLeft: theme.spacing(1.625),
            ...theme.custom.appListingPage.deleteButtonTextStyle
        },
        hoverBtn: {
            height: theme.spacing(4),
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(2),
            borderRadius: theme.spacing(2),
            marginLeft: theme.spacing(1),
            ...theme.custom.appListingPage.hoverButtonStyle
        },
        shareBtn: {
            '& .MuiButton-startIcon': {
                margin: `${theme.spacing(0.5)}px ${theme.spacing(1)}px 0px 0px`,
            }
        },
        createBtn: {
            ...theme.custom.appListingPage.createBtn,
        },
        titleSection: {
            marginTop: theme.spacing(4),
            paddingBottom: theme.spacing(2),
            paddingTop: theme.spacing(3),
        },
        titleContainer: {
            display: "flex",
            alignItems: "center"
        },
        defaultThumbnail: {
            ...theme.custom.appListingPage.defaultAppThumbnail
        },
        editBtn: {
            backgroundSize: theme.spacing(2.5),
            ...theme.custom.appListingPage.editButtonIcon
        },
        titleApps: {
            flexGrow: 1,
            textAlign: 'left'
        },
        title: {
            ...theme.custom.appListingPage.listHeaderTextStyle
        },
        searchIcon: {
            height: theme.spacing(5),
            paddingLeft: theme.spacing(1.375),
            paddingRight: theme.spacing(1.375),
            marginRight: theme.spacing(2),
            ...theme.custom.appListingPage.searchButtonStyles
        },
        loaderContainer: {
            width: "cal(100%-75px)",
            height: "60vh",
            backgroundColor: theme.palette.secondary.light,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ...theme.custom.appListingPage.styles
        },
        searchField: {
            [`screen and @media (min-width: 540px)`]: {
                verticalAlign: 'top',
                horizontalAlign: 'right',
                position: 'absolute',
                right: '356px',
                minHeight: '40px'
            },
            marginRight: theme.spacing(2),
            ...theme.custom.appListingPage.appSearchFieldStyle,
            '& .MuiInput-underline:hover:not(.Mui-disabled)::before ': {
                display: 'none'
            },
            '& .MuiInput-underline::after': {
                display: 'none'
            },
            '& .MuiInput-underline::before ': {
                display: 'none'
            },
            '& .MuiInput-underline': {
                borderBottom: "none"
            }
        },
        tableArea: {
            ...theme.custom.appListingPage.styles
        },
        applicationList: {
            '& .MuiPaper-root': {
                backgroundColor: theme.custom.appListingPage.styles.backgroundColor,
                '& .MuiTable-root:first-child': {
                    '& .MuiTableBody-root': {
                        backgroundColor: theme.custom.appListingPage.styles.backgroundColor
                    }
                }
            },
        },
        ownerChip: {
            marginLeft: theme.spacing(2)
        },
        appTable: {
            '& .MuiTable-root': {
                padding: theme.spacing(1),
            }
        },
        searchPendingAvatarCell: {
            display: 'flex',
            alignItems: 'center'
        },
        searchPendingNameSkeleton: {
            marginLeft: theme.spacing(1.5),
            flexGrow: 1
        },
        searchPendingCenteredSkeleton: {
            margin: '0 auto'
        },
        searchPendingRightAlignedSkeleton: {
            marginLeft: 'auto'
        }
    })
);
